import { render, staticRenderFns } from "./LoginCredentials.vue?vue&type=template&id=88265868&scoped=true"
import script from "./LoginCredentials.vue?vue&type=script&lang=js"
export * from "./LoginCredentials.vue?vue&type=script&lang=js"
import style0 from "./LoginCredentials.vue?vue&type=style&index=0&id=88265868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88265868",
  null
  
)

export default component.exports